// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProseMirror {
  .collaboration-cursor {
    &__caret {
      @apply border-r border-l border-black pointer-events-none -ml-[1px] -mr-[1px] relative break-normal;
    }

    &__label {
      @apply rounded rounded-tl-none text-black text-xs font-semibold -left-[1px] leading-none py-0.5 px-1.5 absolute -top-[1.4em] select-none whitespace-nowrap;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/RichTextEditor/src/styles/partials/collab.css"],"names":[],"mappings":"AAAA;EACE;IACE;MACE,mGAAmG;IACrG;;IAEA;MACE,0JAA0J;IAC5J;EACF;AACF","sourcesContent":[".ProseMirror {\n  .collaboration-cursor {\n    &__caret {\n      @apply border-r border-l border-black pointer-events-none -ml-[1px] -mr-[1px] relative break-normal;\n    }\n\n    &__label {\n      @apply rounded rounded-tl-none text-black text-xs font-semibold -left-[1px] leading-none py-0.5 px-1.5 absolute -top-[1.4em] select-none whitespace-nowrap;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
